import { render, staticRenderFns } from "./OverviewButtons.vue?vue&type=template&id=0191f815&"
import script from "./OverviewButtons.vue?vue&type=script&lang=js&"
export * from "./OverviewButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0191f815')) {
      api.createRecord('0191f815', component.options)
    } else {
      api.reload('0191f815', component.options)
    }
    module.hot.accept("./OverviewButtons.vue?vue&type=template&id=0191f815&", function () {
      api.rerender('0191f815', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/hotels/hotel/OverviewButtons.vue"
export default component.exports